<template>
    <div
        class="CAlert"
        :class="[
            {
                'rounded-md': !props.fullWidth,
                'items-center space-x-6 p-6': props.prominent,
                'bg-primary-100 text-primary-950 dark:bg-primary-950/40 dark:text-primary-100': props.variant === 'info',
                'bg-primary-50 text-gray-800 dark:bg-primary-950 dark:text-txt-body': props.variant === 'info2',
                'bg-green-400/20 dark:bg-green-900/30': props.variant === 'success',
                'bg-secondary-50 text-gray-800 dark:bg-secondary-950/40 dark:text-txt-body': props.variant === 'warning',
                'bg-red-500 dark:bg-red-700': props.variant === 'danger'
            },
            props.fullWidth ? 'py-3.5' : 'p-3.5'
        ]"
    >
        <div :class="{ 'container': props.fullWidth }">
            <div class="flex space-x-3" :class="{ 'justify-center': props.center }">
                <CIcon v-if="props.icon" class="mt-0.5" :name="props.icon" :size="iconSize" />
                <div
                    class="CAlert--content text-sm leading-4.5"
                    :class="{
                        'text-lg leading-snug': props.prominent,
                        'text-center': props.center
                    }"
                >
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import CIcon from '@/components/ui/CIcon.vue'
import { computed } from 'vue'

type AlertVariant = 'info' | 'success' | 'warning' | 'danger' | 'info2'

interface Props {
    variant: AlertVariant
    icon?: string
    prominent?: boolean
    fullWidth?: boolean
    center?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    icon: '',
    prominent: false,
    fullWidth: false,
    center: false
})

const iconSize = computed(() => (props.prominent ? 'large' : 'small'))
</script>

<style lang="postcss" scoped>
.CAlert {
    &--content {
        & > *:last-child {
            margin-bottom: 0;
        }

        & :deep(a) {
            font-weight: 500;
            text-decoration: underline;

            &:hover {
                text-decoration: none;
            }
        }
    }
}
</style>
